import { game, user } from '../store/store';
import GameM from '../model/Game';
import UserM from '../model/User';
import { apiUrlGet, apiUrlIOGet, apiUrlWSGet, obDefaultValGet } from './common';
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { io } from 'socket.io-client';

let gameSess = '';

game.subscribe((val) => gameSess = val);

let gameEventSource = null;
let wsGame = null;
let wsRecoveryCount = 0;

export async function sumGameInit() {
    wsInit();
    const url = apiUrlGet('session/init');
    try {
        let res = await fetch(url,{
            credentials: 'include',
            // mode: "no-cors",            
        });
        if ('json' in res) {
            const sessOb = await res.json();
            await sessObInit(sessOb);                  
        }           
    } catch (err) {
        console.error('err', err);        
    }
}

async function sessObInit(sessOb) {
    const gameOb = obDefaultValGet(sessOb, 'game', null);
    const userId = obDefaultValGet(sessOb, 'uId', '');
    const playerName = obDefaultValGet(sessOb, 'playerName', '');
    
    gameInit(gameOb);
    await userInit(userId, playerName);
}

// function wsRecover() {
//     if (wsRecoveryCount < 100) {
//         wsRecoveryCount++;
//         wsErrCloseListenersRemove();
//         wsGame.close();
//         wsGame = null;
//         sumGameInit();
//     }
// }

function wsErrCloseListenersRemove() {
    wsGame.removeEventListener('close', wsOnClose);
    wsGame.removeEventListener('error', wsOnError);
}

function wsErrCloseListenersInit() {
    wsGame.addEventListener('close', wsOnClose);
    wsGame.addEventListener('error', wsOnError);    
}

function wsOnClose(ev) {
    console.log('ws close', wsRecoveryCount); 
    const socketUrl = apiUrlWSGet();
    wsGame = new WebSocket(socketUrl);
    let tryCount = 0;
    const intervalCall = setInterval(() => {
        if (tryCount >= 100) {
            clearInterval(intervalCall);            
        }
        if (wsGame.readyState === 1) {
            clearInterval(intervalCall);
            wsGame.addEventListener('open', function (event) {
                console.log(`Connected`);
            });
        
            wsGame.addEventListener('message', function (event) {
                const gameOb = JSON.parse(event.data);
                console.log('message - gameOb', gameOb);
                game.set(new GameM(gameOb));
            });
    
            wsErrCloseListenersInit();
            const gameId = gameSess.id;
            if (gameId !== '') {
                wsGameJoin(gameId);                
            }
        }
        tryCount++;
        console.log('ws status tryCount: ', tryCount);
    }, 100);
    // wsRecover();
}

function wsOnError(ev) {
    console.log('ws error: ', err);   
    // wsRecover();
}

function wsInit() {
    if (wsGame === null) {
        const socketUrl = apiUrlWSGet();

        wsGame = new WebSocket(socketUrl);

        wsGame.addEventListener('open', function (event) {
            console.log(`Connected`);
        });
    
        wsGame.addEventListener('message', function (event) {
            const gameOb = JSON.parse(event.data);
            game.set(new GameM(gameOb));
        });

        wsErrCloseListenersInit();

        // const wsConnectedInit = () => {
        // };

        // if (wsGame.readyState === 1) {
        //     wsConnectedInit();                
        // } else {
        //     setTimeout(() => {
        //         wsConnectedInit();
        //     }, 500);    
        // }
    
    }    
}

function wsGameJoin(gameId) {
    const data = {
        msgType: 'gameJoin',
        payload: gameId,
    };
    wsGame.send(JSON.stringify(data));
}

function gameInit(gameOb) {
    if (gameOb !== null) {
        game.set(new GameM(gameOb));
        wsGameJoin(gameOb.id);
    } else {
        game.set(new GameM());
    }
}

async function userInit(userId, playerName='') {
    if (userId !== '') {
        const url = apiUrlGet(`user/${userId}`);
        const res = await fetch(url);
        let userOb = await res.json();
        userOb.playerName = playerName;
        user.set(new UserM(userOb));
    } else {
        user.set(new UserM({ playerName }));
    }    
}

